export const messages = {
  en: {
    reportPayFeeDetail: {
      payFeeOrder: 'Pay Fee Order',
      payFeeDetail: 'Pay Fee Detail',
      prePayFeeOrder: 'Pre Pay Fee Order',
      selectStartTime: 'Please select start time',
      selectEndTime: 'Please select end time',
      selectPrimeRate: 'Please select payment method',
      selectState: 'Please select fee status',
      payerObjName: 'Room number or license plate number',
      cashierName: 'Cashier',
      search: 'Search',
      reset: 'Reset',
      export: 'Export',
      orderId: 'Order ID',
      orderType: 'Order Type',
      payOrder: 'Pay Order',
      preOrder: 'Pre Order',
      roomOwner: 'Room/Owner',
      feeItems: 'Fee Items',
      feeTimePeriod: 'Fee Time Period',
      detailReceivableReceived: 'Detail Receivable/Received',
      orderReceivableReceived: 'Order Receivable/Received',
      arrivalAmount: 'Actual Arrival Amount (Yuan)',
      feeState: 'Fee Status',
      payWay: 'Payment Method',
      payTime: 'Pay Time',
      accountDeduction: 'Account Deduction (Yuan)',
      discount: 'Discount',
      giftAmount: 'Gift Amount (Yuan)',
      lateFee: 'Late Fee (Yuan)',
      area: 'Area (Square Meters)',
      parking: 'Parking',
      remark: 'Remark',
      subtotal: 'Subtotal',
      total: 'Total',
      receivable: 'Receivable',
      yuan: 'Yuan',
      received: 'Received',
      deduction: 'Deduction',
      discountNote: 'Discount Amount: Discount amount generated under discount rules and discount no arrears rules',
      deductionNote: 'Deduction Amount: Deduction amount generated under deduction rules',
      giftNote: 'Gift Amount: Amount of the month to be paid under the gift rules',
      lateFeeNote: 'Late Fee: Violation amount generated under violation late fee rules, additional late fee to be paid',
      selectFeeStartTime: 'Please select fee start time',
      selectFeeEndTime: 'Please select fee end time',
      selectFeeType: 'Please select fee type',
      selectFeeItem: 'Please select fee item',
      feeTypeFeeItem: 'Fee Type > Fee Item',
      payableReceivableAmount: 'Payable/Receivable Amount (Yuan)',
      receivedAmount: 'Received Amount (Yuan)',
      discountDeduction: 'Discount/Deduction Amount (Yuan)',
      feeName: 'Fee Name',
      payObject: 'Pay Object',
      ownerName: 'Owner Name',
      cycle: 'Cycle',
      receivableAmount: 'Receivable Amount',
      remainAmount: 'Remain Amount',
      prePayPeriod: 'Pre Pay Period',
      state: 'State',
      discountAmount: 'Discount Amount',
      prePayTime: 'Pre Pay Time',
      cashier: 'Cashier',
    }
  },
  zh: {
    reportPayFeeDetail: {
      payFeeOrder: '缴费订单',
      payFeeDetail: '缴费明细',
      prePayFeeOrder: '预存明细',
      selectStartTime: '请选择开始时间',
      selectEndTime: '请选择结束时间',
      selectPrimeRate: '请选择支付方式',
      selectState: '请选择费用状态',
      payerObjName: '房屋编号或者车牌号',
      cashierName: '收银员',
      search: '查询',
      reset: '重置',
      export: '导出',
      orderId: '订单号',
      orderType: '订单类型',
      payOrder: '缴费单',
      preOrder: '预付单',
      roomOwner: '房号/业主',
      feeItems: '费用项',
      feeTimePeriod: '缴费时间段',
      detailReceivableReceived: '明细应收/实收',
      orderReceivableReceived: '订单应收/实收',
      arrivalAmount: '实际到账(元)',
      feeState: '费用状态',
      payWay: '支付方式',
      payTime: '缴费时间',
      accountDeduction: '账户抵扣(元)',
      discount: '优惠',
      giftAmount: '赠送金额(元)',
      lateFee: '滞纳金(元)',
      area: '面积(平方米)',
      parking: '车位',
      remark: '说明',
      subtotal: '小计',
      total: '大计',
      receivable: '应收',
      yuan: '元',
      received: '实收',
      deduction: '减免',
      discountNote: '优惠金额：打折规则和打折无欠费规则下产生的优惠金额',
      deductionNote: '减免金额：减免规则下产生的减免金额',
      giftNote: '赠送金额：赠送规则下赠送月份应缴的金额',
      lateFeeNote: '滞纳金：违约滞纳金规则下产生的违约金额，需额外缴纳的滞纳金',
      selectFeeStartTime: '请选择收费开始时间',
      selectFeeEndTime: '请选择收费结束时间',
      selectFeeType: '请选择费用类型',
      selectFeeItem: '请选择收费项',
      feeTypeFeeItem: '费用类型>费用项',
      payableReceivableAmount: '应缴/应收金额(元)',
      receivedAmount: '实收金额(元)',
      discountDeduction: '优惠/减免金额(元)',
      feeName: '费用名称',
      payObject: '付费对象',
      ownerName: '业主名称',
      cycle: '周期',
      receivableAmount: '应收金额',
      remainAmount: '剩余金额',
      prePayPeriod: '预付期',
      state: '状态',
      discountAmount: '优惠金额',
      prePayTime: '预付时间',
cashier: '收银员'
    }
  },
  'zh-TW': {
    reportPayFeeDetail: {
      payFeeOrder: '繳費訂單',
      payFeeDetail: '繳費明細',
      prePayFeeOrder: '預存明細',
      selectStartTime: '請選擇開始時間',
      selectEndTime: '請選擇結束時間',
      selectPrimeRate: '請選擇支付方式',
      selectState: '請選擇費用狀態',
      payerObjName: '房屋編號或者車牌號',
      cashierName: '收銀員',
      search: '查詢',
      reset: '重置',
      export: '匯出',
      orderId: '訂單號',
      orderType: '訂單類型',
      payOrder: '繳費單',
      preOrder: '預付單',
      roomOwner: '房號/業主',
      feeItems: '費用項',
      feeTimePeriod: '繳費時間段',
      detailReceivableReceived: '明細應收/實收',
      orderReceivableReceived: '訂單應收/實收',
      arrivalAmount: '實際到賬(元)',
      feeState: '費用狀態',
      payWay: '支付方式',
      payTime: '繳費時間',
      accountDeduction: '帳戶抵扣(元)',
      discount: '優惠',
      giftAmount: '贈送金額(元)',
      lateFee: '滯納金(元)',
      area: '面積(平方米)',
      parking: '車位',
      remark: '說明',
      subtotal: '小計',
      total: '大計',
      receivable: '應收',
      yuan: '元',
      received: '實收',
      deduction: '減免',
      discountNote: '優惠金額：打折規則和打折無欠費規則下產生的優惠金額',
      deductionNote: '減免金額：減免規則下產生的減免金額',
      giftNote: '贈送金額：贈送規則下贈送月份應繳的金額',
      lateFeeNote: '滯納金：違約滯納金規則下產生的違約金額，需額外繳納的滯納金',
      selectFeeStartTime: '請選擇收費開始時間',
      selectFeeEndTime: '請選擇收費結束時間',
      selectFeeType: '請選擇費用類型',
      selectFeeItem: '請選擇收費項',
      feeTypeFeeItem: '費用類型>費用項',
      payableReceivableAmount: '應繳/應收金額(元)',
      receivedAmount: '實收金額(元)',
      discountDeduction: '優惠/減免金額(元)',
      feeName: '費用名稱',
      payObject: '付費對象',
      ownerName: '業主名稱',
      cycle: '週期',
      receivableAmount: '應收金額',
      remainAmount: '剩餘金額',
      prePayPeriod: '預付期',
      state: '狀態',
      discountAmount: '優惠金額',
      prePayTime: '預付時間',
      cashier: '收銀員'
    }
  }
}